import { Guide } from "./Guide";

export interface EventGuide {
    guide: Guide;
    status: EventGuideStatus;
}

export enum EventGuideStatus {
    PENDING = "pending",
    CONFIRMED = "confirmed",
    DECLINED = "declined",
}

export const EventGuideStatusCopy: { [key in EventGuideStatus]: string } = {
    [EventGuideStatus.CONFIRMED]: "Guide confirmed assignment",
    [EventGuideStatus.PENDING]: "Pending guide confirmation of assignment",
    [EventGuideStatus.DECLINED]: "Guide declined assignment",
};
